import { render, staticRenderFns } from "./FileChatContent.vue?vue&type=template&id=54c3de9e&scoped=true"
import script from "./FileChatContent.vue?vue&type=script&lang=js"
export * from "./FileChatContent.vue?vue&type=script&lang=js"
import style0 from "./FileChatContent.vue?vue&type=style&index=0&id=54c3de9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3de9e",
  null
  
)

export default component.exports